import { useEffect, useRef } from 'react';

const INTERVAL_MS = 30 * 60 * 1000; // 30 minutes

/**
 * Invisible background component that polls /version.json every 30 minutes.
 * When the deployed version changes (new build), it triggers a hard reload so
 * users always run the latest code without needing to manually refresh.
 */
export default function VersionChecker() {
  const knownVersion = useRef(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const { version } = await res.json();
        if (!version) return;

        if (knownVersion.current === null) {
          // First load — record the version currently deployed
          knownVersion.current = version;
        } else if (version !== knownVersion.current) {
          // A new build was deployed — reload to pick up latest assets
          window.location.reload(true);
        }
      } catch {
        // Network error or version.json absent — do nothing
      }
    };

    checkVersion();
    const timer = setInterval(checkVersion, INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return null;
}
